import _ from "lodash";
import { Types } from "./smartPensionActions";
import { INTEGRATION_VARIABLE, INTEGRATION_TYPE, INTEGRATION_NAME } from "./config";

const smartPensionReducers = (state, action) => {
	switch (action.type) {
		case Types.SMART_PENSION_UPDATE_PAY_PERIOD: {
			let newState = _.cloneDeep(state);
			const { payPeriods } = newState.integration?.[INTEGRATION_TYPE]?.[INTEGRATION_VARIABLE] || {};

			const period = action.period;

			const updatedPayPeriods = (() => {
				const existingPayPeriod = payPeriods.find((p) => p.payPeriodId === period.payPeriodId);

				if (existingPayPeriod) {
					return payPeriods.map((p) => (p.payPeriodId === period.payPeriodId ? period : p));
				} else {
					return [...payPeriods, period];
				}
			})();

			newState.integration[INTEGRATION_TYPE] = {
				...newState.integration?.[INTEGRATION_TYPE],
				[INTEGRATION_VARIABLE]: {
					...newState.integration?.[INTEGRATION_TYPE]?.[INTEGRATION_VARIABLE],
					payPeriods: updatedPayPeriods,
				},
			};

      return newState;
		}
		case Types.SMART_PENSION_SENDING_PAY_PERIOD: {
			let newState = _.cloneDeep(state);

			const sending = newState.integration?.[INTEGRATION_TYPE]?.[INTEGRATION_VARIABLE]?.sendingPayroll;

			let sendingPayroll = [...(Array.isArray(sending) ? sending : [])];

			if (action.status) {
				sendingPayroll.push(action.periodId);
			} else {
				sendingPayroll = sendingPayroll?.filter((item) => item != action.periodId);
			}

			newState.integration[INTEGRATION_TYPE] = {
				...newState.integration?.[INTEGRATION_TYPE],
				[INTEGRATION_VARIABLE]: {
					...newState.integration?.[INTEGRATION_TYPE]?.[INTEGRATION_VARIABLE],
					sendingPayroll,
				},
			};

			return newState;
		}
		case Types.SMART_PENSION_OPTIONS: {
			let newState = _.cloneDeep(state);

			newState.integration[INTEGRATION_TYPE][INTEGRATION_VARIABLE] = {
				...newState.integration?.[INTEGRATION_TYPE]?.[INTEGRATION_VARIABLE],
				...action.options,
			};
			return newState;
		}
		case Types.SMART_PENSION_ERRORS_MODAL: {
			let newState = _.cloneDeep(state);

			newState.integration[INTEGRATION_TYPE][INTEGRATION_VARIABLE] = {
				...newState.integration?.[INTEGRATION_TYPE]?.[INTEGRATION_VARIABLE],
				errorsModal: action.payPeriodId,
			};

			return newState;
		}
		default:
			return state;
	}
};

export default smartPensionReducers;
